import WeaponArt from './WeaponArt.jsx'
import CoinIcon from './CoinIcon.jsx'
import { RARITY_COLORS, RARITY_LABELS, WEAR_SHORT, getWearFriendlyLabel, formatCoinsNum, formatFloat } from '../lib/format.js'
import '../styles/item-card.css'

/**
 * Карточка предмета. Используется везде: в кейсе, инвентаре, рулетке, крафте.
 * Цветная полоса сверху — редкость, она же задаёт свечение при наведении.
 */
export default function ItemCard({
  item,
  selected = false,
  onClick,
  footer,
  size = 'md',
  showFloat = false,
  chance,
  disabled = false,
}) {
  const rarity = item.rarity ?? 'consumer'
  const color = RARITY_COLORS[rarity]
  const interactive = Boolean(onClick) && !disabled
  const Tag = interactive ? 'button' : 'div'
  const wearFriendly = getWearFriendlyLabel(item)

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      onClick={interactive ? onClick : undefined}
      disabled={disabled && interactive ? true : undefined}
      className={[
        'item-card',
        `item-card-${size}`,
        selected ? 'is-selected' : '',
        interactive ? 'is-interactive' : '',
        disabled ? 'is-disabled' : '',
        item.wear ? 'has-wear' : '',
        item.stattrak ? 'has-st' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ '--rarity': color }}
      title={`${item.name} | ${item.skin}${wearFriendly ? ` (${wearFriendly})` : ''}`}
    >
      <span className="item-card-bar" />

      <div className="item-card-badges-top-right">
        {item.wear && <span className="item-card-wear">{WEAR_SHORT[item.wear] ?? item.wear}</span>}
        {item.stattrak && <span className="item-card-st-badge">ST</span>}
      </div>

      <span className="item-card-art">
        <WeaponArt
          image={item.image}
          rarity={rarity}
          size={size}
          title={`${item.name} ${item.skin}`}
        />
      </span>

      <span className="item-card-body">
        <span className="item-card-name">{item.name}</span>
        <span className="item-card-skin">{item.skin}</span>

        {showFloat && item.floatValue !== undefined && (
          <span className="item-card-float">float {formatFloat(item.floatValue)}</span>
        )}

        <span className="item-card-meta">
          <span className="item-card-rarity">{RARITY_LABELS[rarity]}</span>
          {(item.priceKopecks ?? item.valueKopecks) !== undefined && (
            <span className="item-card-price">
              <span>{formatCoinsNum(item.priceKopecks ?? item.valueKopecks)}</span>
              <CoinIcon size="xs" />
            </span>
          )}
        </span>

        {chance !== undefined && <span className="item-card-chance">{chance}</span>}
        {footer}
      </span>

      {selected && (
        <span className="item-card-check" aria-hidden="true">
          ✓
        </span>
      )}
    </Tag>
  )
}
